import React from 'react'
import ForHer from '../../../components /ProductPage/ItemsProduct/ForherProduct'

const ForHerPage = () => {
  return (
    <div>
      <ForHer />
    </div>
  )
}

export default ForHerPage
